import { PaymentTermItem } from '@/models/quote-template';
import { QuotePaymentTermItemService } from '@/services/quote-payment-term-service';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const quotePaymentTermService = new QuotePaymentTermItemService();

export const state = {
  paymentTermItems: [] as PaymentTermItem[]
};

type QuotesState = typeof state;

export const mutations: MutationTree<QuotesState> = {
  SET_QUOTE_PAYMENT_TERM_ITEMS(state, payload: PaymentTermItem[]) {
    state.paymentTermItems = payload;
  },

  ADD_QUOTE_PAYMENT_TERM_ITEM(state, payload: PaymentTermItem) {
    state.paymentTermItems.push(payload);
  },

  UPDATE_QUOTE_PAYMENT_TERM_ITEM(state, payload: PaymentTermItem) {
    const index = state.paymentTermItems.findIndex(
      (paymentTermItems: PaymentTermItem) => paymentTermItems.id === payload.id
    );
    state.paymentTermItems.splice(index, 1, payload);
  },

  REMOVE_QUOTE_PAYMENT_TERM_ITEM(state, payload: number) {
    const index = state.paymentTermItems.findIndex(
      (paymentTermItems: PaymentTermItem) => paymentTermItems.id === payload
    );
    state.paymentTermItems.splice(index, 1);
  }
};

export const actions: ActionTree<QuotesState, QuotesState> = {
  createQuotePaymentTerm: async ({ commit }, payload: PaymentTermItem) =>
    quotePaymentTermService
      .createQuotePaymentTerm(payload)
      .then((paymentTermItems: PaymentTermItem) =>
        commit('ADD_QUOTE_PAYMENT_TERM_ITEM', paymentTermItems)
      ),

  fetchQuotePaymentTerms: async ({ commit }, language?: string) =>
    quotePaymentTermService
      .fetchQuotePaymentTerms(language)
      .then((paymentTermItems: PaymentTermItem[]) => {
        commit('SET_QUOTE_PAYMENT_TERM_ITEMS', paymentTermItems);
      }),

  fetchQuotePaymentTerm: async ({ commit }, payload: number) =>
    quotePaymentTermService
      .fetchQuotePaymentTerm(payload)
      .then((paymentTermItems: PaymentTermItem) => {
        const index = state.paymentTermItems.findIndex(
          (v: PaymentTermItem) => v.id === paymentTermItems.id
        );
        if (index === -1) {
          commit('ADD_QUOTE_PAYMENT_TERM_ITEM', paymentTermItems);
        } else {
          commit('UPDATE_QUOTE_PAYMENT_TERM_ITEM', paymentTermItems);
        }
        return paymentTermItems;
      }),

  updateQuotePaymentTerm: async ({ state, commit }, payload: PaymentTermItem) =>
    quotePaymentTermService
      .updateQuotePaymentTerm(payload)
      .then((paymentTermItems: PaymentTermItem) => {
        const index = state.paymentTermItems.findIndex(
          (v: PaymentTermItem) => v.id === paymentTermItems.id
        );
        if (index === -1) {
          commit('ADD_QUOTE_PAYMENT_TERM_ITEM', paymentTermItems);
        } else {
          commit('UPDATE_QUOTE_PAYMENT_TERM_ITEM', paymentTermItems);
        }
      }),

  deleteQuotePaymentTerm: async ({ commit }, payload: number) =>
    quotePaymentTermService.deleteQuotePaymentTerm(payload).then(() => {
      commit('REMOVE_QUOTE_PAYMENT_TERM_ITEM', payload);
    })
};

export const getters: GetterTree<QuotesState, QuotesState> = {
  getQuotePaymentTermById: state => (id: number) =>
    state.paymentTermItems.find(paymentTermItems => paymentTermItems.id === id)
};
